<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->
<input #input="" type="text" class="full-width" [required]="required" [placeholder]="placeholder" [disabled]="disabled" [value]="textValue" (input)="onInput($event.target.value)" (blur)="onTouched()" [matAutocomplete]="auto">
<mat-autocomplete #auto="matAutocomplete" class="grid-overlay-panel" [displayWith]="stringifyTime" (optionSelected)="onOptionSelected($event.option.value)">
  <mat-option *ngFor="let time of times" [value]="time">{{ time | typeFormat:'ShortTime' }}</mat-option>
</mat-autocomplete>